import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-nissan-information',
    templateUrl: './nissan-information.component.html',
    styleUrls: ['./nissan-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NissanInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
